import { useState } from "react";
import { makeStyles } from "tss-react/mui";
import {
  MiFilterAccordion,
  MiFilterItem,
  MiIcon,
  MiInputTextbox,
  MiInternalDrawer,
  MiTab,
} from "@miplatform/components";
import { ICONS_WEB } from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Box, InputAdornment, Typography } from "@mui/material";
import { CategoryFilterDrawer } from "../../../../components/FilterDrawer/CategoryFilterDrawer";

const tabs = [
  { label: "Items", value: "Items", sx: { width: "50%" } },
  { label: "Item Templates", value: "Item Templates", sx: { width: "50%" } },
];

export function MaterialDrawer({
  open = false,
  onClose,
  planDetails = {},
  resetMaterialDrawerStates,
  hideCloseButton = false,
  disableBreadcrumbsClick = false,
  // item category filter props
  search,
  handleItemSearch,
  categoryFilterOptions,
  selectedCategory,
  selectedAttributeValues,
  handleCategoryClick,
  handleAttributeValueClick,
  // item template filter props
  itemTemplateSearch,
  handleItemTemplateSearch,
  templateFilter,
  seriesOptions,
  handleSeriesOptionFilter,
  filteredAreaTypeOptions,
  handleAreaTypeOptionFilter,
  setOpenItemTemplateResults,
}) {
  const [activeTab, setActiveTab] = useState("Items");

  const { classes, theme } = useStyles();

  const isTabItems = activeTab === "Items";
  const isTabItemTemplates = activeTab === "Item Templates";

  const areaSelectedOptions = filteredAreaTypeOptions
    .filter((option) => templateFilter.areaTypeId.includes(option.id))
    .map((option) => option.name);
  const seriesSelectedOptions = seriesOptions
    .filter((option) => templateFilter.seriesId === option.seriesId)
    .map((option) => option.series);

  const handleActiveTab = (tab) => {
    setActiveTab(tab);
    resetMaterialDrawerStates();
    if (tab === "Item Templates") {
      setOpenItemTemplateResults(true);
    }
  };

  const handleCloseDrawer = () => {
    onClose();
    setActiveTab("Items");
  };

  return (
    <MiInternalDrawer
      removeHeaderMargin
      open={open}
      onClose={!hideCloseButton && handleCloseDrawer}
      title={isTabItems ? "Filter Items" : "Filter Item Templates"}
    >
      <Box className={classes.root}>
        <MiTab
          tabs={tabs}
          currentTab={activeTab}
          onTabChange={handleActiveTab}
          scrollButtons={false}
          borderBottom
        />
        {isTabItems && (
          <CategoryFilterDrawer
            title=""
            categoryFilterOptions={categoryFilterOptions}
            search={search}
            selectedCategory={selectedCategory}
            selectedAttributeValues={selectedAttributeValues}
            setSearch={handleItemSearch}
            handleCategoryClick={handleCategoryClick}
            handleAttributeValueClick={handleAttributeValueClick}
            handleReset={!disableBreadcrumbsClick && resetMaterialDrawerStates}
            handleResetSelection={
              !disableBreadcrumbsClick && resetMaterialDrawerStates
            }
          />
        )}
        {isTabItemTemplates && (
          <Box className={classes.itemTemplatesContainer}>
            <Box className={classes.searchContainer}>
              <MiInputTextbox
                className={classes.inputTextbox}
                placeholder="Search Item Templates"
                value={itemTemplateSearch}
                handleChange={(e) => handleItemTemplateSearch(e.target.value)}
                textfieldProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MiIcon path={mdi[ICONS_WEB.MAGNIFY]} />
                    </InputAdornment>
                  ),
                  endAdornment: search && (
                    <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                      <MiIcon
                        path={mdi[ICONS_WEB.CLOSE]}
                        onClick={() => handleItemTemplateSearch("")}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <MiFilterItem
              title="Customer"
              rightAction={
                <Typography className={classes.rightActionText}>
                  {planDetails.builderName} ({planDetails.builderShortName})
                  <MiIcon path={mdi[ICONS_WEB.LOCK_OUTLINE]} size={0.8} />
                </Typography>
              }
            />
            <MiFilterAccordion
              title="Series"
              selectedOptions={seriesSelectedOptions}
            >
              {seriesOptions.map((option) => {
                const isSelected = templateFilter.seriesId === option.seriesId;
                return (
                  <MiFilterItem
                    key={option.id}
                    title={option.series}
                    handleClick={() =>
                      handleSeriesOptionFilter(option.seriesId)
                    }
                    selected={isSelected}
                    iconPath={ICONS_WEB.CHECK}
                    iconColor={theme.palette.primary.main}
                    showIcon={isSelected}
                  />
                );
              })}
            </MiFilterAccordion>
            <MiFilterAccordion
              title="Areas"
              selectedOptions={areaSelectedOptions}
              showItemCount
            >
              {filteredAreaTypeOptions.map((area) => {
                const isSelected = templateFilter.areaTypeId.includes(area.id);
                return (
                  <MiFilterItem
                    key={area.id}
                    keyVal={area.id}
                    title={area.name}
                    handleClick={() => handleAreaTypeOptionFilter(area)}
                    selected={isSelected}
                    iconPath={ICONS_WEB.CHECK}
                    showIcon={isSelected}
                  />
                );
              })}
            </MiFilterAccordion>
          </Box>
        )}
      </Box>
    </MiInternalDrawer>
  );
}

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    height: "100%",
  },
  rightActionText: {
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    color: theme.palette.grey.main,
    gap: 8,
  },
  itemTemplatesContainer: {
    backgroundColor: "white",
    height: "100%",
    width: 300,
  },
  filterList: {
    overflowY: "auto",
  },
  searchContainer: {
    display: "flex",
    flexDirection: "column",
    position: "sticky",
    top: 0,
    width: "100%",
    padding: theme.spacing(1, 3),
  },
  inputTextbox: {
    padding: theme.spacing(1, 0),
  },
}));
